import { apiEndpoints } from "../apiConfig";
import axiosInstance from "../axiosInstance";

const candidateApi = {
  addCandidate: (payload) => axiosInstance.post(apiEndpoints.addCandidate, payload),
  addIndividualCandidate: (payload) => axiosInstance.post(apiEndpoints.addIndividualCandidate, payload),
  getPosition: () => axiosInstance.get(apiEndpoints.getPosition),
  getReport: (id) => axiosInstance.get(apiEndpoints.getReport(id)),
  viewReport: (id) => axiosInstance.get(apiEndpoints.viewReport(id)),
  sendNotification: (payload) => axiosInstance.post(apiEndpoints.sendNotification, payload),
  addPosition: (positionPayload) => axiosInstance.post(apiEndpoints.addPosition, positionPayload),
  positionGetById: () => axiosInstance.get(apiEndpoints.positionGetById),
  changePositonStatus: (payload) => axiosInstance.post(apiEndpoints.changePositonStatus, payload),
  fetchNewPosition: () => axiosInstance.get(apiEndpoints.fetchNewPosition),
  getOpenPosition: () => axiosInstance.get(apiEndpoints.getOpenPosition),
  addCompanyRating: (companyRating) => axiosInstance.post(apiEndpoints.addCompanyRating, companyRating),
  getExcelData: () => axiosInstance.get(apiEndpoints.getExcelData),
};

export default candidateApi;
